import { z } from "zod";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { moneySchema, quantitySchema, timestampSchema, uuidSchema } from "../common/primitives.js";
import { marketLedgerStatusSchema, positiveQuantitySchema, stockWriteOffStatusSchema, writeOffLossKeySchema, writeOffReasonSchema, } from "./enums.js";
/**
 * Fire / imha (Prompt 16, ADR 0016 §12). Onay motoru `STOCK_WRITE_OFF` (politika yoksa otomatik onay); onayda
 * `WASTE` hareketleri (ortalama maliyetle) ve fiş: kayıp anahtarı (ayar: neden → NORMAL_LOSS / ABNORMAL_LOSS)
 * borç / `INVENTORY` alacak, istasyon boyutuyla.
 */
export const stockWriteOffLineSchema = z.object({
    id: uuidSchema,
    lineNo: z.number().int(),
    productId: uuidSchema,
    productCode: z.string(),
    productName: z.string(),
    lotId: uuidSchema.nullable(),
    lotNo: z.string().nullable(),
    quantity: quantitySchema,
    value: moneySchema.describe("Onayda ortalama maliyetle (kuruş); taslakta tahmini"),
    note: z.string().nullable(),
});
export const stockWriteOffSchema = z.object({
    id: uuidSchema,
    companyId: uuidSchema,
    stationId: uuidSchema,
    stationName: z.string(),
    warehouseId: uuidSchema,
    warehouseCode: z.string(),
    writeOffNo: z.string(),
    reason: writeOffReasonSchema,
    lossKey: writeOffLossKeySchema.describe("Ayara göre kullanılacak (ya da kullanılan) kayıp anahtarı"),
    status: stockWriteOffStatusSchema,
    note: z.string().nullable(),
    totalValue: moneySchema,
    approvalRequestId: uuidSchema.nullable(),
    postedAt: timestampSchema.nullable(),
    postedBy: uuidSchema.nullable(),
    journalEntryId: uuidSchema.nullable(),
    ledgerStatus: marketLedgerStatusSchema,
    lineCount: z.number().int(),
    lines: z.array(stockWriteOffLineSchema).describe("Liste ucunda boş döner; ayrıntı ucunda dolu"),
    createdBy: uuidSchema.nullable(),
    createdAt: timestampSchema,
    version: z.number().int(),
});
export const stockWriteOffPageSchema = pageOf(stockWriteOffSchema);
export const listStockWriteOffsQuerySchema = pageQuerySchema.extend({
    companyId: uuidSchema,
    stationId: uuidSchema.optional(),
    status: stockWriteOffStatusSchema.optional(),
    reason: writeOffReasonSchema.optional(),
});
const writeOffLinesInput = z
    .array(z.object({
    productId: uuidSchema,
    quantity: positiveQuantitySchema,
    lotId: uuidSchema.nullable().default(null).describe("Belirli parti (SKT'si geçen parti)"),
    note: z.string().trim().max(300).nullable().default(null),
}))
    .min(1)
    .max(500);
export const createStockWriteOffSchema = z.object({
    warehouseId: uuidSchema,
    reason: writeOffReasonSchema,
    note: z.string().trim().max(1000).nullable().default(null),
    lines: writeOffLinesInput,
});
/** TASLAK fireyi TAMAMEN değiştirir. */
export const saveStockWriteOffSchema = z.object({
    reason: writeOffReasonSchema,
    note: z.string().trim().max(1000).nullable().default(null),
    lines: writeOffLinesInput,
    version: z.number().int().positive(),
});
export const stockWriteOffActionSchema = z.object({ version: z.number().int().positive() });
export const cancelStockWriteOffSchema = z.object({
    version: z.number().int().positive(),
    reason: z.string().trim().min(3, "İptal nedeni yazın").max(300),
});
//# sourceMappingURL=write-offs.js.map